import type { Hex } from 'viem'

import { type AccountAddress } from '@cowprotocol/cow-sdk'
import { EOA_TWAP_POLL_FUNDS_DAPP_ID } from '@cowprotocol/hook-dapp-lib'
import { ComposableCowPoller } from '@cowprotocol/sdk-composable'

import { POLL_FUNDS_HOOK_GAS_LIMIT } from 'entities/twap/composable-cow-poller.constants'

import { replaceHooksOnAppData } from 'modules/appData'
import type { AppDataInfo, CowHook } from 'modules/appData'

/**
 * Injects `pollFunds(scheduleId)` as a TWAP pre-hook and re-hashes appData.
 * Must run before `buildTwapOrderParamsStruct` so `staticInput` includes the new appData hash.
 * Prepends so JIT funding lands sell tokens on the shed before other pre-hooks run.
 */
export async function injectPollFundsPreHookIntoAppData(
  appData: AppDataInfo,
  { pollerAddress, scheduleId }: { pollerAddress: AccountAddress; scheduleId: Hex },
): Promise<AppDataInfo> {
  const pollFundsHook: CowHook = {
    target: pollerAddress,
    callData: new ComposableCowPoller(pollerAddress).encodePollFunds(scheduleId),
    gasLimit: POLL_FUNDS_HOOK_GAS_LIMIT,
    dappId: EOA_TWAP_POLL_FUNDS_DAPP_ID,
  }

  const existing = appData.doc.metadata.hooks

  return replaceHooksOnAppData(appData, {
    pre: [pollFundsHook, ...(existing?.pre ?? [])],
    ...(existing?.post?.length ? { post: existing.post } : undefined),
  })
}
